import { Box, Stack } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import React from "react";
import { ColorSystemProps, GOI_WEB_URL } from "../../../constants";
import { FullWidthButton } from "../../common/Buttons/FullWidthButton";
import { ClickEventType, ParlorDetailProps } from "../../../types";
import { useOverlay } from "@toss/use-overlay";
import BinsoReserveModal from "../../Modal/BinsoReserveModal";
import { useGoiCall } from "../../../hooks/useGoiCall";
import { useRouter } from "next/router";

dayjs.extend(utc);
dayjs.extend(timezone);

export function BTypeBinsoRealTimeSummary({
  defaultParlor,
  id,
  mainColor,
  event,
}: {
  defaultParlor: ParlorDetailProps;
  id: string;
  mainColor: ColorSystemProps;
  event: ClickEventType;
}) {
  dayjs.locale("ko");
  const now = dayjs().tz("Asia/Seoul");
  const { goiCall } = useGoiCall();
  const router = useRouter();

  // const overlay = useOverlay();

  return (
    <Stack gap="14px" padding="0 20px">
      <Box className="subtitle_18_sb" textAlign="center">
        {defaultParlor.companyname} 실시간 빈소
      </Box>

      <Stack
        className="subtitle_14_b"
        flexDirection="row"
        justifyContent="space-between"
        padding="12px 40px"
        style={{ background: mainColor.c300, color: "white" }}
      >
        <Box>호실</Box>
        <Box>고인명</Box>
        <Box>발인 시각</Box>
      </Stack>

      <Stack
        alignItems="center"
        justifyContent="center"
        padding="67px 0"
        width="100%"
        gap="16px"
      >
        <Box textAlign="center" className="body_14_m gray800">
          고이에서
          <br />
          e하늘장사정보시스템 정보를 바탕으로
          <br />
          전문성 있는 장례 서비스를 제공하며,
          <br />
          빈소 비용을 포함한
          <br />
          장례 견적을 제공해 드리고 있습니다.
        </Box>
        <Stack width="184px" gap="8px">
          <FullWidthButton
            text="24시 장례 상담"
            onClick={() => {
              goiCall();
            }}
            // href="tel:1666-9784"
            event={
              { ...event, trigger_and_target: "goi_call" } as ClickEventType
            }
          />
          <FullWidthButton
            text="장례 비용 알아보기"
            onClick={() => {
              router.push(
                `${GOI_WEB_URL}/match/parlor-requests/${id}/?utm_source=dogsound`
              );
              // overlay.open(({ isOpen, close: onClose }) => {
              //   return (
              //     <BinsoReserveModal
              //       event={event}
              //       parlorName={defaultParlor.companyname}
              //       isOpen={isOpen}
              //       onClose={onClose}
              //     />
              //   );
              // });
            }}
            event={
              {
                ...event,
                trigger_and_target: "opn_reserve_mdl",
              } as ClickEventType
            }
          />
        </Stack>
      </Stack>
      <Box height="2px" style={{ background: "black" }} />
    </Stack>
  );
}
